import React, { useState } from 'react';
import { Modal } from './Modal';
import { formatPrice } from '../../store';

export type PaymentMethod = 'cash' | 'card' | 'transfer';

interface PaymentDialogProps {
  open: boolean;
  title: string;
  /** Qabul qilinadigan maksimal summa — qarzdan ortiq to'lov yozilmaydi. */
  maxAmount: number;
  hint?: string;
  saving?: boolean;
  onClose: () => void;
  onSubmit: (amount: number, method: PaymentMethod) => void;
}

const METHODS: { value: PaymentMethod; label: string }[] = [
  { value: 'cash', label: 'Naqd' },
  { value: 'card', label: 'Karta' },
  { value: 'transfer', label: "O'tkazma" },
];

export const PaymentDialog: React.FC<PaymentDialogProps> = ({
  open, title, maxAmount, hint, saving, onClose, onSubmit,
}) => {
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState<PaymentMethod>('cash');

  const value = Number(amount) || 0;
  const tooMuch = value > maxAmount;
  const invalid = value <= 0 || tooMuch;

  const close = () => {
    setAmount('');
    setMethod('cash');
    onClose();
  };

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (invalid) return;
    onSubmit(value, method);
  };

  return (
    <Modal
      open={open}
      onClose={close}
      title={title}
      size="sm"
      footer={
        <>
          <button type="button" onClick={close} className="btn btn-secondary">
            Bekor qilish
          </button>
          <button type="submit" form="payment-form" disabled={invalid || saving} className="btn btn-primary">
            {saving ? 'Saqlanmoqda...' : 'Qabul qilish'}
          </button>
        </>
      }
    >
      <form id="payment-form" onSubmit={submit} className="space-y-4">
        <div className="flex justify-between text-sm bg-gray-50 rounded-lg px-3 py-2">
          <span className="text-gray-500">{hint || 'Qarz'}</span>
          <span className="font-semibold text-danger-600">{formatPrice(maxAmount)} UZS</span>
        </div>

        <div>
          <label className="label">Summa *</label>
          <input
            type="number"
            className="input"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0"
            autoFocus
          />
          <div className="flex items-center justify-between mt-1">
            <button
              type="button"
              className="text-sm text-primary-800 hover:underline"
              onClick={() => setAmount(String(maxAmount))}
            >
              To'liq summa
            </button>
            {tooMuch && (
              <span className="text-sm text-danger-600">Qarzdan ortiq bo'lishi mumkin emas</span>
            )}
          </div>
        </div>

        <div>
          <label className="label">To'lov usuli</label>
          <div className="flex gap-2">
            {METHODS.map((m) => (
              <button
                key={m.value}
                type="button"
                onClick={() => setMethod(m.value)}
                className={`btn flex-1 ${method === m.value ? 'btn-primary' : 'btn-secondary'}`}
              >
                {m.label}
              </button>
            ))}
          </div>
        </div>
      </form>
    </Modal>
  );
};
